<template lang="pug">
  .wrap
    mySwitch(open-name='Ok' size="lg" close-name='No' color='blue' :value.sync='toggle' disabled)
</template>

<script>
  import mySwitch from 'vue-switch/switch-2.vue'
  
  export default {
    name: 'switch_generico',
    components: {
      mySwitch,
    },
    props: {
      estado: {
        type: String,
        default: '0'
      }
    },
    data() {
      return {
        toggle: false
      }
    },
    watch: {
      estado() {
        console.log(this.estado)
        console.log('Aqui tiene que cambiar')
        this.checarEstado()
      }
    },
    methods: {
      checarEstado() {
        if (this.estado === '0') {
          this.toggle = false
        } else {
          this.toggle = true
        }
      }
    },
    created () {
      this.checarEstado()
    },
  }
</script>

<style lang="css" scoped>
  .vue-switch.s-lg {
    width: 60px;
    height: 25px;
    padding-top: 1px;
  }

  .vue-switch::after {
    top: 3px;
  }
</style>


// WEBPACK FOOTER //
// src/components/checklist_Componentes/switch.vue